export const PricingCardStyles = (theme: any) => ({
    border: "none",
    background:
      "radial-gradient(circle at 50% 0%, hsl(210, 98%, 35%), hsl(210, 100%, 16%))",
    boxShadow: `0 8px 12px hsla(210, 98%, 42%, 0.2)`,
    ...theme.applyStyles("dark", {
      boxShadow: `0 8px 12px hsla(0, 0%, 0%, 0.8)`,
    }),
  });